export default {
    setFeedQueue(state, payload) {
        state.feedAssignmentQueue = payload;
    },
    setNewQueue(state, payload) {
        const queueList = state.feedAssignmentQueue;
        const oldQueue = queueList.find(x => x.isCurrentQueue);
        if (oldQueue) {
            oldQueue.isCurrentQueue = false;
            oldQueue.name = oldQueue.name.replace(" (aktif)", "");
        }
        const newQueue = queueList.find(x => x.id == payload);
        if (newQueue) {
            newQueue.isCurrentQueue = true;
        }
 
    }
}